import { Roles } from '../constants/Roles';

export interface IRole {
  key: Roles;
  value: string;
  level: number;
}

export const translateUserRoleInRole: Record<string, IRole> = {};
translateUserRoleInRole[Roles.ADMIN] = {
  key: Roles.ADMIN,
  value: 'Admin',
  level: 5,
};
translateUserRoleInRole[Roles.ONLINE_ACCOUNT_COORDINATOR] = {
  key: Roles.ONLINE_ACCOUNT_COORDINATOR,
  value: 'Online Account Coordinator',
  level: 4,
};
translateUserRoleInRole[Roles.IMPLEMENTER] = {
  key: Roles.IMPLEMENTER,
  value: 'Implementer',
  level: 4,
};
translateUserRoleInRole[Roles.ONLINE_ACCOUNT_MANAGER] = {
  key: Roles.ONLINE_ACCOUNT_MANAGER,
  value: 'Online Account Manager',
  level: 4,
};
translateUserRoleInRole[Roles.EDI_ANALYST] = {
  key: Roles.EDI_ANALYST,
  value: 'EDI Analyst',
  level: 4,
};
translateUserRoleInRole[Roles.BROKER_CONSULTANT] = {
  key: Roles.BROKER_CONSULTANT,
  value: 'Broker/Consultant',
  level: 4,
};
translateUserRoleInRole[Roles.RENEWAL_COORDINATOR] = {
  key: Roles.RENEWAL_COORDINATOR,
  value: 'Renewal Coordinator',
  level: 4,
};
translateUserRoleInRole[Roles.RENEWAL_ANALYST] = {
  key: Roles.RENEWAL_ANALYST,
  value: 'Renewal Analyst',
  level: 4,
};
translateUserRoleInRole[Roles.ACCOUNT_CLIENT_MANAGER] = {
  key: Roles.ACCOUNT_CLIENT_MANAGER,
  value: 'Account/Client Manager',
  level: 4,
};
translateUserRoleInRole[Roles.ACCOUNT_SUPPORT] = {
  key: Roles.ACCOUNT_SUPPORT,
  value: 'Account Support',
  level: 4,
};
translateUserRoleInRole[Roles.WELLNESS] = {
  key: Roles.WELLNESS,
  value: 'Wellness',
  level: 4,
};
translateUserRoleInRole[Roles.CLIENT] = {
  key: Roles.CLIENT,
  value: 'Client',
  level: 3,
};
translateUserRoleInRole[Roles.EMPLOYEE] = {
  key: Roles.EMPLOYEE,
  value: 'Employee',
  level: 1,
};
